export const CODE_SENT_STATUS = 'Confirmation code sent';
export const WRONG_CODE_STATUS = 'Wrong code';
